import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Employee Information")
  ])
], -1)
const _hoisted_3 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = { class: "row d-flex" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload Employee Image", -1)
const _hoisted_9 = { id: "preview" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col-md-9" }
const _hoisted_12 = { class: "row mt-3 d-flex" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "row mt-3 d-flex" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Passport")
], -1)
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Driving License")
], -1)
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mobile")
], -1)
const _hoisted_26 = { class: "row mt-3 d-flex" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gender")
], -1)
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_33 = { class: "row mt-3" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Role", -1)
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Designation")
], -1)
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Date of Birth", -1)
const _hoisted_42 = { class: "row mt-3" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "National ID")
], -1)
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Name")
], -1)
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mother's Name")
], -1)
const _hoisted_49 = { class: "row mt-3" }
const _hoisted_50 = { class: "col-md-8" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_54 = { class: "row mt-3" }
const _hoisted_55 = { class: "col-md-8" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent District")
], -1)
const _hoisted_59 = { class: "card mb-5 mb-xl-10" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#user_account",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Add User Account")
  ])
], -1)
const _hoisted_61 = {
  id: "user_account",
  class: "collapse show"
}
const _hoisted_62 = { class: "collapse show" }
const _hoisted_63 = { class: "card-body border-top p-5" }
const _hoisted_64 = { "data-kt-stepper-element": "content" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "" }, "Password")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      name: "password",
      class: "fv-plugins-message-container invalid-feedback"
    }, "System will generate a password and send to your email.")
  ])
], -1)
const _hoisted_69 = { class: "row mt-3" }
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Password")
], -1)
const _hoisted_72 = { class: "col-md-6" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Confirm Password")
], -1)
const _hoisted_74 = { class: "d-flex" }
const _hoisted_75 = ["data-kt-indicator"]
const _hoisted_76 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_77 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_78 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[24] || (_cache[24] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_img,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employee.employee_img) = $event)),
                    name: "employee_logo",
                    ref: "employeeFileInput",
                    onChange: _ctx.employeePhoto,
                    type: "file",
                    class: "form-control"
                  }, null, 8, ["modelValue", "onChange"]),
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.employee_url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.employee_url
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "contact_person_image",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.employee.tranche_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employee.tranche_id) = $event)),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: trans.id,
                              label: trans.label,
                              value: trans.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(trans.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Partner",
                        modelValue: _ctx.employee.entity_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.employee.entity_id) = $event)),
                        style: {"width":"100%"},
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getEmployeeDesignation()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (ent) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: ent?.entity_info?.id,
                              label: ent?.entity_info?.entity_short_name,
                              value: ent?.entity_info?.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(ent.entity_info?.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_passport,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employee.employee_passport) = $event)),
                        name: "passport",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_driving_license,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.employee.employee_driving_license) = $event)),
                        name: "driving_license",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_mobile,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.employee.employee_mobile) = $event)),
                        name: "mobile",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "mobile",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_email,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.employee.employee_email) = $event)),
                        name: "employeeEmail",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "employeeEmail",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Gender",
                        modelValue: _ctx.employee.employee_gender,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.employee.employee_gender) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Male",
                            value: "Male"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Male")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Female",
                            value: "Female"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Female")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Other",
                            value: "Other"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Other")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "gendernew",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Religion",
                        modelValue: _ctx.employee.employee_religion,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.employee.employee_religion) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Islam",
                            value: "Islam"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Islam")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Hindu",
                            value: "Hindu"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hindu")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Christian",
                            value: "Christian"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Christian")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Buddhist",
                            value: "Buddhist"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Buddhist")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "religion",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_name,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.employee.employee_name) = $event)),
                    type: "text",
                    name: "name",
                    class: "form-control",
                    rows: "3"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "name",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Role",
                    modelValue: _ctx.employee.role,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.employee.role) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDesignation, (designation) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: designation.id,
                          label: designation.label,
                          value: designation.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(designation.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "designation",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.designation,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.employee.designation) = $event)),
                    name: "designation",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_el_form_item, {
                    prop: "date",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.employee.employee_dob,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.employee.employee_dob) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        type: "date",
                        name: "dob",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_nid,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.employee.employee_nid) = $event)),
                    name: "nid",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_father_name,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.employee.employee_father_name) = $event)),
                    name: "fathers_name",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_mother_name,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.employee.employee_mother_name) = $event)),
                    name: "mothers_name",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_present_address,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.employee.employee_present_address) = $event)),
                    name: "present_address",
                    class: "form-control",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Present District",
                    modelValue: _ctx.employee.employee_present_district,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.employee.employee_present_district) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: district.id,
                          label: district.district_name_eng,
                          value: district.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_permanent_address,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.employee.employee_permanent_address) = $event)),
                    name: "permanent_address",
                    class: "form-control"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Permanent District",
                    modelValue: _ctx.employee.employee_permanent_district,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.employee.employee_permanent_district) = $event)),
                    name: "permanent_district",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: district.id,
                          label: district.district_name_eng,
                          value: district.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.employee.employee_email,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.employee.employee_email) = $event)),
                      name: "employeeEmail",
                      type: "email",
                      class: "form-control",
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "employeeEmail",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _hoisted_68,
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.user.password,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.user.password) = $event)),
                      name: "password",
                      class: "form-control",
                      type: "password"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "password",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.user.password_confirmation,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.user.password_confirmation) = $event)),
                      name: "confirmPassword",
                      class: "form-control",
                      type: "password"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "confirmPassword",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-success",
              type: "submit"
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                    _createTextVNode(" Submit "),
                    _createElementVNode("span", _hoisted_77, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                    _createTextVNode(" Please wait... "),
                    _hoisted_79
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_75)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}